<template>
    <div>
        <div class="tooltip-notification" @click="openGrid">
            <div class="tooltip-notification__img-wrapper">
                <img class="tooltip-notification__img" :src='img' :alt="'icon ' + title">

                <div :class="[
                    'tooltip-notification__count',
                    {
                        'tooltip-notification__count--error': this.status === 'error',
                        'tooltip-notification__count--alert': this.status === 'alert',
                        'tooltip-notification__count--oke': this.status === 'oke' ||  count === 0,
                    }
                ]">
                    <span v-if="this.count">{{ this.count }}</span>
                </div>
            </div>
            <p>{{ title }}</p>
        </div>
        <Modal v-if="showModal === id"  @close="closeModal" :title="title" :id="id"></Modal>
    </div>

</template>
<script>
import Modal from "../components/Modal.vue";

export default {
    name: 'NotificationItem',
    components: {
        Modal,
    },
    data() {
        return {
            notificationItem: null,
            showModal: null,
            count: 0,
            status: null,
            bundle: null,
            buttons: null,
        }
    },
    props: {
        id: String,
        title: String,
        img: String,
    },
    methods: {
        // getting status and counter for notification
        async fetchData() {
            const request = await fetch(this.$getSetting('paths.baseCms') + '/notifications/' + this.id, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            // check for errors
            if ( ! request.ok)  {
                if (request.status === 404) {
                    console.log('404: Could not find.');
                    this.status = "error";
                }
                console.log('Error: Check status code', request.status);
                console.log(request)
                this.status = "error";
                return;
            }

            const response = await request.json()

            this.count = response.count;
            this.status = response.status;
            this.buttons = response.buttons;
        },
        //modal open and close
        openModal (id) {
            this.showModal = id;
        },
        closeModal () {
            this.showModal = null;
        },
        openGrid () {
            if ( ! this.buttons || ! this.buttons.details) {
                return;
            }

            this.$router.push({
                name: 'grid',
                params: {
                    bundle: this.buttons.details.link.bundle,
                    gridDefinition: this.buttons.details.link.grid
                }
            });
        }
    },
    created() {
        this.fetchData();
    }
}
</script>
